<ng-container>
  @if (navigationSteps.length) {
    @switch (this.navigationSteps[currentStepIndex].stepKey) {
      @case ('TABLE_DRAWING') {
        <app-table-drawing
          [documentFile]="documentFile"
          [navigationSteps]="navigationSteps"
          (exitClicked)="redirectBackToCategorization()"
          (nextClicked)="completeTableDrawing()"
          (tableMergeSelection)="updateTableMergeSelection($event)"
        ></app-table-drawing>
      }
      <!-- this is the non-editable table preview, like what we have in normal column adjustement step on right -->
      @case ('TABULATION') {
        <app-table-tabulation
          [cells]="cells"
          [columnStructure]="columnStructure"
          [pageImage]="currentTableMergeSelection.pageImage"
          [navigationSteps]="navigationSteps"
          (exitClicked)="redirectBackToCategorization()"
          (nextClicked)="completeTableAdjustments()"
          (saveClicked)="saveAdjustedTables()"
        ></app-table-tabulation>
      }
      <!-- this is the manual review table -->
      @case ('FINAL_REVIEW') {
        <app-final-review
          [translationDict]="htDataService.translationDict"
          [currency]="currency"
          [navigationSteps]="navigationSteps"
          [columnStructure]="columnStructure"
          [pageImage]="currentTableMergeSelection.pageImage"
          [formatDataLabel]="formatDataLabel"
          (exitClicked)="redirectBackToCategorization()"
          (nextClicked)="completeTableMerge()"
          (updateRoundingSelection)="updateRoundingSelection($event)"
          [roundingSelection]="roundingSelection"
        ></app-final-review>
      }
    }
  }

</ng-container>

@if (isLoading) {
  <div class="loader__overlay">
    <div class="loader"></div>
  </div>
}
